export function reviewsSlider() {
    let $reviews = $(".reviews-slider");
    if ($reviews.length) {
        $reviews.each(function () {
            const slider = $(this);
            const sliderControls = slider.next();
            const dots = sliderControls.find(".slick-dots-wrap");
            const arrowPrev = sliderControls.find(".arrow-prev");
            const arrowNext = sliderControls.find(".arrow-next");

            slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
                dots: true,
                appendDots: dots,
                prevArrow: arrowPrev,
                nextArrow: arrowNext
            });
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/reviewsSlider.js